/**
 *
 * SearchBoxComponent implementation
 *
 */

import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { IconCancel, IconSearch } from 'svgIcons/MotionPortalIcons';
import './_style.scss';

// eslint-disable-next-line react/display-name
const SearchBoxComponent = React.memo((props) => {
	const [focusedInput, setFocusedInput] = useState(false);
	const [searchInputValue, setSearchInputValue] = useState(props.value || '');
	const inputRef = useRef(null);
	const showClearButton = !props.disabled && searchInputValue !== '';

	useEffect(() => {
		if (props.value === undefined || props.value === null) {
			setSearchInputValue('');
		} else {
			setSearchInputValue(props.value);
		}
	}, [props.value]);

	const handleInputChange = (e) => {
		const inputValue = e.target.value;
		setSearchInputValue(inputValue);
		const trimmedSearchInputValue = inputValue.trim();
		if (/^https?:\/\//i.test(trimmedSearchInputValue)) {
			return;
		}

		if (typeof props.onChange === 'function') {
			props.onChange(trimmedSearchInputValue);
		}
	};

	const handleClear = () => {
		setSearchInputValue('');
		if (typeof props.onChange === 'function') {
			props.onChange('');
		}
		if (typeof props.onClear === 'function') {
			props.onClear();
		}
		inputRef.current?.focus();
	};

	return (
		<div className={`search-field ${props.disabled ? 'disabled' : ''} ${props.className ?? ''} ${focusedInput ? 'highlight' : ''}`}>
			<div className={`search-field-component ${showClearButton ? 'has-clear-button' : ''}`}>
				<div className='search-input-container'>
					<input id={props.id}
						ref={inputRef}
						onChange={handleInputChange}
						type='text'
						className='form-control'
						placeholder={props.placeholder}
						value={searchInputValue}
						maxLength={props.maxLength}
						disabled={props.disabled}
						onFocus={() => { setFocusedInput(true); }}
						onBlur={() => { setFocusedInput(false); }}
						onKeyDown={props.onKeyDown}
					/>
				</div>
				{showClearButton &&
					<button
						className='close-button-container'
						onClick={handleClear}
						type='button'>
						<IconCancel viewBox='13 13 20 20' />
					</button>
				}
				<div>
				</div>
			</div>
			<button
				className='search-button-container'
				onClick={() => {
					if (!(props.iconDisabled ?? false) && typeof props.onIconClick === 'function') {
						props.onIconClick(searchInputValue);
					}
				}}
				style={{
					cursor: !(props.iconDisabled ?? false) && props.onIconClick ? 'pointer' : 'default',
					opacity: props.iconDisabled ?? false ? 0.5 : 1
				}}
				type='button'>
				<IconSearch />
			</button>
		</div>
	);
});

SearchBoxComponent.propTypes = {
	id: PropTypes.string,
	className: PropTypes.string,
	onKeyDown: PropTypes.func,
	onIconClick: PropTypes.func,
	onChange: PropTypes.func.isRequired,
	onClear: PropTypes.func,
	placeholder: PropTypes.string.isRequired,
	value: PropTypes.string,
	disabled: PropTypes.bool,
	iconDisabled: PropTypes.bool,
	maxLength: PropTypes.number
};

export default SearchBoxComponent;
